module.exports = __webpack_public_path__ + "img/SVG curve-2.ee542e14.svg";